import {PageHolder, PageContent} from "./InformatDefaultPage.Styled";
import {InformatFooter} from "../../../03organisms/informat/footer/InformatFooter";
import {InformatHeader} from "../../../03organisms/informat/header/InformatHeader";
import {ZendeskHelp} from "pu-crossproduct-components/build/components/Organisms/Widgets/ZendeskHelp";

export const InformatDefaultPage: React.FC = props => {
    return <PageHolder>
        <InformatHeader />
        <PageContent>{props.children}</PageContent>
        <ZendeskHelp widgetKey={"33b22df0-f88f-4f20-829a-dacc8bead20b"} zendeskSettings={{
            webWidget: {
                helpCenter: {
                    filter: {
                        category: "360002845579"
                    }
                },
                position: {
                    horizontal: "right",
                    vertical: "bottom"
                },
                offset: {
                    vertical: "80px",
                    horizontal: "5%"
                },
                zIndex: 50
            }
        }} />
        <InformatFooter />
    </PageHolder>
}
